module.exports = __webpack_public_path__ + "static/media/icoedit.8ad5114f.svg";